module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRDIxMDM0IiBkPSJNLjUuNWgzMDB2MjAwSC41eiIvPjxwYXRoIGZpbGw9IiMwMDdFM0EiIGQ9Ik01MC41IDUwLjVoMjAwdjEwMGgtMjAweiIvPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjE2MyIgY3k9IjEwMC41IiByPSIzMy4zMzMiLz48Y2lyY2xlIGZpbGw9IiMwMDdFM0EiIGN4PSIxNzUuNSIgY3k9IjEwMC41IiByPSIzMy4zMzMiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-mv.svg
// module id = g20S
// module chunks = 2